export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_03_Loop.8d958727.mp4";